import $ from "jquery";
export default function contactFormBase() {

    //Switch
    let sliderPositionForm = $('.avu-switch .form-contact-switch input[type="radio"]:checked').closest('.wpcf7-list-item').hasClass('last') ? 'calc(50% - 2px)' : '2px';
    $('.avu-switch .form-contact-switch input[type="radio"]:checked').closest('.avu-switch').find('.switch-slider').css('left', sliderPositionForm);

    //Select
    $('.form-select').on('click', function() {
        $(this).toggleClass('rotated');
    }).on('blur', function() {
        $(this).removeClass('rotated');
    });
}